import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Download, Eye } from 'lucide-react'

import moment from 'moment'
import { ReportContext } from '../../../providers/report'
import 'moment/locale/pt-br'

import { Table } from '../../ui/Table'

moment.locale('pt-br')

const REPORT_TAB_MAP = {
  'Relatório de Pacote': 'pacotes',
  'Relatório de Pet': 'pets',
  'Relatório de Cliente': 'clientes',
  'Relatório de Agendamento': 'agendamentos',
}

const SORTABLE_COLUMN_KEYS = {
  Nome: 'name',
  Status: 'status',
  'Solicitação': 'createdAt',
  'Finalização': 'updatedAt',
}

const CAMPOS_DATA = ['createdAt', 'updatedAt']

function compara(a, b, campo) {
  const x = a?.[campo]
  const y = b?.[campo]

  if (x === y) return 0
  if (!x) return 1
  if (!y) return -1

  if (CAMPOS_DATA.includes(campo)) return moment(x).valueOf() - moment(y).valueOf()

  return String(x).localeCompare(String(y), 'pt-BR', { sensitivity: 'base' })
}

/**
 * Esta aba era a unica dos relatorios ainda em tabela do Material UI, com a cor
 * laranja escrita na mao e sem ordenacao. Passou a usar o Table compartilhado,
 * igual as outras abas. A lista vem inteira do ReportContext (sem paginacao no
 * servidor), entao a ordenacao e feita aqui mesmo.
 */
function Downloads({ setValue }) {
  const { getDownloads, downloads } = useContext(ReportContext)
  const [loading, setLoading] = useState(false)
  const [sort, setSort] = useState({ sortBy: 'createdAt', sortOrder: 'desc' })

  const handleDownloadClick = (file) => {
    if (!file) return
    window.open(file, '_blank', 'noopener,noreferrer')
  }

  const handleSortColumn = (sortBy) => {
    setSort((atual) => ({
      sortBy,
      sortOrder: atual.sortBy === sortBy && atual.sortOrder === 'asc' ? 'desc' : 'asc',
    }))
  }

  const linhas = useMemo(() => {
    const lista = Array.isArray(downloads) ? downloads : []
    if (!sort.sortBy) return lista

    const fator = sort.sortOrder === 'asc' ? 1 : -1
    return [...lista].sort((a, b) => compara(a, b, sort.sortBy) * fator)
  }, [downloads, sort])

  useEffect(() => {
    const fetchDownloads = async () => {
      setLoading(true)
      await getDownloads()
      setLoading(false)
    }
    fetchDownloads()
  }, [])

  return (
    <div className="mt-4">
      <Table.Root name="table-downloads-report">
        <Table.Header
          columns={[
            'Nome:minmax(180px, 320px)',
            'Status:140px',
            'Solicitação:130px',
            'Finalização:130px',
            'Relatório:130px',
            'Arquivo:100px',
          ]}
          sortableConfig={{
            sortBy: sort.sortBy,
            sortOrder: sort.sortOrder,
            onSort: handleSortColumn,
            columnKeys: SORTABLE_COLUMN_KEYS,
          }}
        />

        <Table.Content isLoading={loading}>
          {linhas.map((row) => {
            const finalizado = row.status === 'FINALIZADO'

            return (
              <Table.Line key={`${row.name}-${row.createdAt}`}>
                <Table.Item title={row.name}>{row.name}</Table.Item>
                <Table.Item>{row.status}</Table.Item>
                <Table.Item>{moment(row.createdAt).format('DD/MM/YY')}</Table.Item>
                <Table.Item>
                  {finalizado ? moment(row.updatedAt).format('DD/MM/YY') : '-'}
                </Table.Item>
                <Table.Item>
                  <button
                    type="button"
                    title={`Abrir ${row.name}`}
                    disabled={!REPORT_TAB_MAP[row.name]}
                    onClick={() => setValue(REPORT_TAB_MAP[row.name])}
                    className="flex items-center gap-1 border-b border-transparent font-medium text-scale-600 hover:border-current disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:border-transparent"
                  >
                    <Eye size={16} aria-hidden="true" />
                    Ver
                  </button>
                </Table.Item>
                <Table.Item>
                  <button
                    type="button"
                    title={finalizado ? 'Baixar' : 'Disponível apenas após finalização'}
                    disabled={!finalizado || !row.file}
                    onClick={() => handleDownloadClick(row.file)}
                    className="flex items-center text-scale-600 disabled:cursor-not-allowed disabled:text-gray-400"
                  >
                    <Download size={18} aria-hidden="true" />
                  </button>
                </Table.Item>
              </Table.Line>
            )
          })}
        </Table.Content>
      </Table.Root>
    </div>
  )
}

export default Downloads
